import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import SocialFeedSection from './components/SocialFeedSection'
import FloatingNotice from './components/FloatingNotice'

import HomePage from './pages/HomePage'
import BookingPage from './pages/BookingPage'
import ContactPage from './pages/ContactPage'
import ValgfagIndexPage from './pages/ValgfagIndexPage'
import CmsPage from './pages/CmsPage'
import GalleryPage from './pages/GalleryPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'
import AdminBookingsPage from './pages/AdminBookingsPage'

export default function App() {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <div className="flex min-h-screen flex-col bg-white text-[#36454F] antialiased font-sans">
      {/* Scroll restoration to top on route change */}
      <ScrollToTop />

      {/* Sticky Header with Desktop Nav and Mobile Drawer (<1200px) */}
      <Navbar />

      {/* Main Routes View */}
      <div className="flex-1">
        <Routes>
          {/* Forside */}
          <Route path="/" element={<HomePage />} />

          {/* Book rundvisning */}
          <Route path="/rundvisning" element={<BookingPage />} />
          <Route path="/book-rundvisning" element={<BookingPage />} />

          {/* Galleri underside */}
          <Route path="/billeder" element={<GalleryPage />} />

          {/* Kontakt */}
          <Route path="/kontakt" element={<ContactPage />} />

          {/* Valgfag */}
          <Route path="/undervisning/valgfag" element={<ValgfagIndexPage />} />
          <Route path="/valgfag" element={<ValgfagIndexPage />} />
          <Route path="/undervisning/valgfag/:slug" element={<CmsPage />} />

          {/* Om skolen & undersider */}
          <Route path="/om-os" element={<CmsPage fixedSlug="om-os" />} />
          <Route path="/om-os/:slug" element={<CmsPage />} />

          {/* Undervisning & undersider */}
          <Route path="/undervisning" element={<CmsPage fixedSlug="undervisning" />} />
          <Route path="/undervisning/brobygning" element={<CmsPage fixedSlug="undervisning-brobygning" categoryFilter="undervisning" />} />
          <Route path="/brobygning" element={<Navigate to="/undervisning/brobygning" replace />} />
          <Route path="/undervisning/juniormesterlaere" element={<CmsPage fixedSlug="juniormesterlaere" />} />
          <Route path="/juniormesterlaere" element={<CmsPage fixedSlug="juniormesterlaere" />} />
          <Route path="/undervisning/:slug" element={<CmsPage />} />

          {/* Enkelte folkeskolens fag */}
          <Route path="/undervisning-i-dansk" element={<CmsPage fixedSlug="undervisning-i-dansk" />} />
          <Route path="/undervisning-i-matematik" element={<CmsPage fixedSlug="undervisning-i-matematik" />} />
          <Route path="/undervisning-i-biologi" element={<CmsPage fixedSlug="undervisning-i-biologi" />} />
          <Route path="/undervisning-i-engelsk" element={<CmsPage fixedSlug="undervisning-i-engelsk" />} />
          <Route path="/undervisning-i-fysik-kemi" element={<CmsPage fixedSlug="undervisning-i-fysik-kemi" />} />
          <Route path="/undervisning-i-geografi" element={<CmsPage fixedSlug="undervisning-i-geografi" />} />
          <Route path="/undervisning-i-idraet" element={<CmsPage fixedSlug="undervisning-i-idraet" />} />
          <Route path="/undervisning-i-historie" element={<CmsPage fixedSlug="undervisning-i-historie" />} />
          <Route path="/undervisning-i-samfundsfag" element={<CmsPage fixedSlug="undervisning-i-samfundsfag" />} />
          <Route path="/undervisning-i-kristendom" element={<CmsPage fixedSlug="undervisning-i-kristendom" />} />
          <Route path="/undervisning-i-tysk" element={<CmsPage fixedSlug="undervisning-i-tysk" />} />

          {/* DLD (Udviklingsmæssig sprogforstyrrelse) */}
          <Route path="/dld" element={<CmsPage fixedSlug="dld" />} />
          <Route path="/naar-dit-barn-har-dld" element={<CmsPage fixedSlug="dld" />} />
          <Route path="/ordblindeefterskole/dld" element={<CmsPage fixedSlug="dld" />} />
          <Route path="/om-os/dld" element={<CmsPage fixedSlug="dld" />} />

          {/* APD (Auditiv processeringsforstyrrelse) */}
          <Route path="/apd" element={<CmsPage fixedSlug="apd" />} />
          <Route path="/naar-dit-barn-har-apd" element={<CmsPage fixedSlug="apd" />} />
          <Route path="/ordblindeefterskole/apd" element={<CmsPage fixedSlug="apd" />} />
          <Route path="/om-os/apd" element={<CmsPage fixedSlug="apd" />} />

          {/* Nøglesider med faste slugs */}
          <Route path="/faciliteter" element={<CmsPage fixedSlug="faciliteter" />} />
          <Route path="/hverdagen" element={<CmsPage fixedSlug="hverdagen" />} />
          <Route path="/skolekreds" element={<CmsPage fixedSlug="skolekreds" />} />
          <Route path="/lovkrav" element={<CmsPage fixedSlug="lovkrav" />} />
          <Route path="/ordblindeefterskole" element={<CmsPage fixedSlug="ordblindeefterskole" />} />
          <Route path="/skolevaegring" element={<CmsPage fixedSlug="skolevaegring" />} />
          <Route path="/ordblindeefterskole/skolevaegring" element={<CmsPage fixedSlug="skolevaegring" />} />
          <Route path="/efterskole-i-8-klasse" element={<CmsPage fixedSlug="efterskole-i-8-klasse" />} />
          <Route path="/ordblindeefterskole/efterskole-i-8-klasse" element={<CmsPage fixedSlug="efterskole-i-8-klasse" />} />
          <Route path="/efterskole-8-klasse" element={<CmsPage fixedSlug="efterskole-i-8-klasse" />} />
          <Route path="/efterskole-i-9-klasse" element={<CmsPage fixedSlug="efterskole-i-9-klasse" />} />
          <Route path="/ordblindeefterskole/efterskole-i-9-klasse" element={<CmsPage fixedSlug="efterskole-i-9-klasse" />} />
          <Route path="/efterskole-9-klasse" element={<CmsPage fixedSlug="efterskole-i-9-klasse" />} />
          <Route path="/9-klasse" element={<CmsPage fixedSlug="efterskole-i-9-klasse" />} />
          <Route path="/efterskole-i-10-klasse" element={<CmsPage fixedSlug="efterskole-i-10-klasse" />} />
          <Route path="/ordblindeefterskole/efterskole-i-10-klasse" element={<CmsPage fixedSlug="efterskole-i-10-klasse" />} />
          <Route path="/efterskole-10-klasse" element={<CmsPage fixedSlug="efterskole-i-10-klasse" />} />
          <Route path="/10-klasse" element={<CmsPage fixedSlug="efterskole-i-10-klasse" />} />
          <Route path="/undervisning-for-ordblinde" element={<Navigate to="/ordblindeefterskole" replace />} />
          <Route path="/efterskole-soenderjylland" element={<CmsPage fixedSlug="efterskole-soenderjylland" />} />
          <Route path="/specialefterskole" element={<CmsPage fixedSlug="specialefterskole" />} />
          <Route path="/efterskolernes-dag-2026" element={<CmsPage fixedSlug="efterskolernes-dag-2026" />} />
          <Route path="/efterskole-sport" element={<CmsPage fixedSlug="efterskole-sport" />} />
          <Route path="/vi-tilbyder" element={<CmsPage fixedSlug="vi-tilbyder" />} />
          <Route path="/bliv-elev" element={<Navigate to="/book-rundvisning" replace />} />

          {/* Nyheder / artikler */}
          <Route path="/nyheder/:slug" element={<CmsPage />} />

          {/* Fejlkoder */}
          <Route path="/403" element={<ForbiddenPage />} />

          {/* Internt administrationsmodul for rundvisninger */}
          <Route path="/admin" element={<AdminBookingsPage />} />
          <Route path="/admin/rundvisning" element={<AdminBookingsPage />} />

          {/* Generiske CMS slug routes */}
          <Route path="/:slug" element={<CmsPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>

      {/* SoMe sektion over Footer kun på forsiden */}
      {isHomePage && <SocialFeedSection />}

      {/* Global Footer */}
      <Footer />

      {/* Persistent floating notice om ledige pladser */}
      <FloatingNotice />
    </div>
  )
}
